
import React from 'react';
import { PersonRoleSelector } from './PersonRoleSelector';
import { TFormDataEmpresaPersonas, TRepresentantesRoles } from '../types/EmpresaTypes';

type TRepresentantesRoleManagementProps = {
  label: string;
  integrantes: TFormDataEmpresaPersonas[];
  onChange: (index: number, value: TRepresentantesRoles) => void;
  error?: string;
  required?: boolean;
}

const ROLE_OPTIONS = ["Titular", "Apoderado", "No participa"]

export const RepresentantesRoleManagement: React.FC<TRepresentantesRoleManagementProps> = ({ label, integrantes, onChange, error, required }) => (
        <div className='representantes'>
          <label>{label}</label>
          {integrantes.map((p, i) => (
            <div key={i} className="form-representantes">
              <label>Nombre: {p.firstName} {p.lastName} Dni: {p.idDocument}</label>
              <PersonRoleSelector
                name={`rol-${i}`}
                value={p.rol ?? ''}
                onChange={(e) => onChange(i, e.target.value as TRepresentantesRoles)}
                options={ROLE_OPTIONS}
                required={required}
                error={error ? 'Debe seleccionar un rol' : undefined}
              />
            </div>
          ))}
          
        {error && <div className="invalid-feedback">{error}</div>}
    </div>
);
